// extracted by mini-css-extract-plugin
export default {"TermsAndConditions":"ScrollingTermsAndCond_TermsAndConditions__3ymM9"};